import React, { useState } from "react";
import ReportModal from "./ReportModal";
import { TbReport } from "react-icons/tb";
import { toast } from "react-toastify";
import accessURL from "../../../../components/utils/access";

interface ApiSubmissionData {
  objective: string;
  dateOfVisit: string;
  content: number[];
  products: number[];
  followupPlan: string;
  customer: string;
}

const CreateReport: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    localStorage.removeItem("dateOfVisit");
    localStorage.removeItem("customerDetails");
    window.location.reload();
  };

  const handleReportSubmit = async (formData: ApiSubmissionData) => {
    setIsLoading(true);
    try {
      const response = await accessURL.post("/reports/create", formData);

      if (response.status === 409 || response.data.code === 409) {
        toast.error(response.data.message || "Report already exists!");
        setIsLoading(false);
        return;
      }

      if (
        response.data.code === 400 &&
        response.data.message.includes("future dates")
      ) {
        toast.error(response.data.message);
        setIsLoading(false);
        return;
      }

      if (response.status === 201) {
        toast.success("Report created successfully!");
        setTimeout(() => {
          window.location.reload();
          handleCloseModal();
        }, 2000);
        setIsLoading(false);
      } else {
        toast.error("Failed to create report. Please try again.");
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleOpenModal}
        className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded text-xl"
      >
        <TbReport />
        Create Report
      </button>
      <div className="py-10">
        {isModalOpen && (
          <ReportModal
            onClose={handleCloseModal}
            onSubmit={handleReportSubmit}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
};

export default CreateReport;
